import CasButton, { ICasButton } from "./CasButton";

export function CasSecondaryButton(props:ICasButton) {
    return <CasButton 
                color="secondary"
                variant="outlined"
                {...props} />
}